import {
  CURRENT_CONTEXT_CHANGED,
  CURRENT_DOCUMENT_CHANGED,
  ADDED_FILE_TO_TASKLIST,
  CLOSED_FILE_IN_TASKLIST
} from "./types";

/**
 * Returns an action with an updated current context
 * @param {String} newContext
 */
export const currentContextChanged = newContext => ({
  type: CURRENT_CONTEXT_CHANGED,
  newContext
});

/**
 * Dispatches a context switch
 */
export const selectContext = context => dispatch =>
  dispatch(currentContextChanged(context));

/**
 * Returns an action with the new document identifier
 * which should be added to the task list
 */
export const documentAddedToTaskList = (document, context) => ({
  type: ADDED_FILE_TO_TASKLIST,
  document,
  context
});

/**
 * Dispatches adding a file to the task list
 */
export const addDocumentToTaskList = (document, inContext) => dispatch =>
  dispatch(documentAddedToTaskList(document, inContext));

/**
 * Returns an action with an updated current document
 * @param {String} newContext
 */
export const currentDocumentChanged = (newDocument, context) => ({
  type: CURRENT_DOCUMENT_CHANGED,
  newDocument,
  context
});

/**
 * Dispatches a document switch
 */
export const selectDocument = (document, inContext) => dispatch => {
  dispatch(currentDocumentChanged(document, inContext));
  dispatch(addDocumentToTaskList(document, inContext));
};

/**
 * Returns an action with the new document identifier
 * which should be removed from the task list
 */
export const documentRemovedFromTaskList = (document, context) => ({
  type: CLOSED_FILE_IN_TASKLIST,
  document,
  context
});

/**
 * Dispatches closing a file in the task list
 */
export const closeDocumentInTaskList = (document, inContext) => dispatch => {
  dispatch(documentRemovedFromTaskList(document, inContext));
  dispatch(selectDocument(null, inContext));
};



// WEBPACK FOOTER //
// ./src/actions/tasklist.js